import style from './ModalSampleType.module.css';

import edit from 'assets/svg/edit-01.svg';
import add from 'assets/svg/add-01.svg';
import closeSVG from 'assets/svg/close-01.svg';

import { observer } from 'mobx-react-lite';
import React from 'react';
import { address_server_short, COLORS, PUBLIC_ASSETS } from 'config';
import { TypeSampleStore } from 'store/context/TypeSampleStore';
import { getTypeSamples } from 'services/list.services';
import Icon from 'helpers/components/Icon';
import classNames from 'classnames';
import { STORAGE_TYPE } from 'consts/storage.consts';
import { modalStore } from 'store/mobx/modal.store';
import { Store } from 'store/context/Store';

const ModalSampleType = observer((props) => {
  const { column, line, mode, storageId, packId, onClose, type = STORAGE_TYPE.puck } = props;
  const typeSampleStore = React.useContext(TypeSampleStore);
  const storeContext = React.useContext(Store);

  const [types, setTypes] = React.useState([]);

  React.useEffect(() => {
    loadTypes();
  }, []);

  const loadTypes = async () => {
    let res = await getTypeSamples();
    setTypes(res);
  };

  const [selectedTypeId, setSelectedTypeId] = React.useState(null);

  const navToSampleType = (modeOpen) => {
    if (modeOpen == 'new') {
      typeSampleStore.clearTypeSampleField();
    }

    let newContext = JSON.parse(JSON.stringify(mode));
    const newTab = {
      name: 'Карточка образца',
      path: 'Карточка образца',
      mode: newContext,
      id: new Date().getTime(),
    };

    localStorage.setItem('active_tabs', newTab.id);
    mode.setTabs([...mode.tabs, newTab]);
    mode.setActiveTabId(newTab.id);
    mode.setVisibleAdd(false);
    mode.setPath('Карточка образца');
  };

  const addClick = () => {
    if (selectedTypeId != null) {
      storeContext.setEmptySelectedSample(line, column, storageId, packId);
      storeContext.setSampleField('type', selectedTypeId);
      modalStore.openModal('sampleEdit', { mode, storeContext, selectedTypeId }, true);
    }
  };

  const clickOnItem = (id) => {
    if (id == selectedTypeId) {
      addClick();
    } else {
      setSelectedTypeId(id);
    }
  };

  const editTypeSample = async () => {
    await typeSampleStore.setTypeSampleId(selectedTypeId);
    navToSampleType('edit');
  };

  if (types?.length === 0) return null;

  return (
    <div className={style.sampleDeatilBox}>
      <button className={style.closeButton} onClick={onClose}>
        <img src={closeSVG} alt="" />
      </button>
      {type === STORAGE_TYPE.puck && (
        <div className={style.titlePlace}>
          Позиция: {line} / {column}
        </div>
      )}
      <div className={style.actionSample}>
        <div className={style.actionSampleAdd}>
          <div className={'hover_hint_parent'}>
            <div onClick={addClick}>
              <Icon
                disable={selectedTypeId != null ? false : true}
                color={selectedTypeId != null ? COLORS.color_brand : COLORS.bg_inactive}
                src={add}
                width={'20px'}
                height={'20px'}
              />
            </div>
            <div className={'hover_hint'}>Добавить новый образец</div>
          </div>
        </div>
        <div>
          <div className={'hover_hint_parent'}>
            <div onClick={editTypeSample}>
              <Icon
                disable={selectedTypeId != null ? false : true}
                color={selectedTypeId != null ? COLORS.color_brand : COLORS.bg_inactive}
                src={edit}
                width={'20px'}
                height={'20px'}
              />
            </div>
            <div className={'hover_hint'}>Редактировать выбранный тип</div>
          </div>
        </div>
      </div>
      <div className={style.row}>
        <span>Выберите тип образца: </span>
        <div className={style.sampleTypescontainer}>
          {types.map((i) => (
            <div
              className={classNames(style.containerMiniImg, style.hoverHintParent, {
                [style.selectType]: i.id == selectedTypeId,
              })}
              key={i.id}
              onClick={() => {
                clickOnItem(i.id);
              }}
            >
              <img className={style.itemImg} src={address_server_short + PUBLIC_ASSETS + i.icon} />
              <div className={style.hoverHint}>{i.name}</div>
            </div>
          ))}
        </div>
        <div className={style.rowAddTypeSample}>
          <div className={style.rowAddTypeSamplebtn} onClick={() => navToSampleType('new')}>
            Определить новый тип
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalSampleType;
